/*
 * @Description: In User Settings Edit
 * @Author: your name
 * @Date: 2019-09-10 17:40:19
 * @LastEditTime: 2019-09-10 17:40:19
 * @LastEditors: your name
 */
import axios from 'axios'
let TIMER = null
let LOADING = null
axios.defaults.withCredentials = true
// 默认参数
const DEFAULT_OPTIONS = Object.freeze({
    // 是否自动错误提示
    error: true,
    errorConfig: {
        type: 'message'
    },
    // 是否显示加载中状态
    load: true,
    // 默认超时时间
    timeout: 1000 * 20,
    // 当前获取到数据类型
    type: 'json',
    // 多少秒之后再显示loading
    beforeLoadingTime: 300,
    // 当前是否是上传文件
    upload: false,
    // 接口地址
    apiUrl: '',
    // 接口请求方式
    method: 'POST',
    // 是否不在headers中添加authorization(用户token)
    n_authorization:false,
    // 全替换headers
    replaceHeaders:false,
})
export default class Ajax {
    _Vue
    // 当前默认url路径
    _URL
    // 当前路由实例
    _Router

    constructor(Vue, config, router) {
        this._Vue = Vue
        this._URL = config.API
        this._Router = router
    }

    objectToFormData(obj, form, namespace) {
        var fd = form || new FormData();
        var formKey;
        if (obj instanceof Array) {
            for (let i = 0, len = obj.length; i < len; i++) {
                let item = obj[i]
                if (typeof item === 'object' && !(item instanceof File)) {
                    this.objectToFormData(item, fd, namespace + '[' + i + ']');
                } else {
                    // 若是数组则在关键字后面加上[]
                    fd.append(namespace + '[' + i + ']', item)
                }
            }
        } else {
            for (var property in obj) {
                if (obj.hasOwnProperty(property) && obj[property]) {

                    if (namespace) {
                        // 若是对象，则这样
                        formKey = namespace + '[' + property + ']';
                    } else {
                        formKey = property;
                    }

                    // if the property is an object, but not a File,
                    // use recursivity.
                    if (typeof obj[property] === 'object' && !(obj[property] instanceof File)) {
                        // 此处将formKey递归下去很重要，因为数据结构会出现嵌套的情况
                        this.objectToFormData(obj[property], fd, formKey);
                    } else {

                        // if it's a string or a File object
                        fd.append(formKey, obj[property]);
                    }

                }
            }
        }
        return fd;
    }

    /**
     * 发送ajax请求
     * @param {String} url 接口地址
     * @param {Object} params 请求参数
     * @param {Object} options 自定义参数
     *  - error {Boolean} 是否需要自动处理错误信息
     *  - load  {Boolean} 是否需要显示加载中样式
     */
    sendRequest(url, params = {}, options = {}) {
        clearTimeout(TIMER)
        TIMER = null
        // 合并默认配置和传递进来的配置参数
        options = {
            ...DEFAULT_OPTIONS,
            ...options
        }
        // 开启loading
        if (options.load) {
            TIMER = window.setTimeout(() => {
                LOADING = this._Vue.prototype.$loading()
            }, options.beforeLoadingTime)
        }
        // 动态设置请求头
        // let headers = {
        //     'Content-Type': 'application/json;charset=UTF-8'
        // }
        
        let headers = {
            'Content-Type': 'application/x-www-form-urlencoded'
        };
        if(options.replaceHeaders && options.headers){
            headers = options.headers
        }else{
            headers = Object.assign(headers,options.headers)
        }

        if(!options.n_authorization){
            try{
                let userInfo = JSON.parse(sessionStorage.getItem("userInfo") || "{}");
                if(userInfo.jti){
                    headers['Authorization'] = userInfo.jti
                }
            }catch(err){
                err;
            }
        }
        
        let newParams = {};
        if(options.method.toUpperCase() == "GET" || headers["Content-Type"].indexOf("application/x-www-form-urlencoded")>-1){
            newParams.params = params;
        }
        
        let baseURL = ''
        baseURL = options.apiUrl || this._URL
        return new Promise((reslove, reject) => {
            axios(Object.assign({
                url,
                baseURL,
                method: options.method,
                data: params,
                timeout: options.timeout,
                headers: headers,
                responseType: options.type
            },newParams)).then(data => {
                if (data.status === 200) {
                    let {
                        status,
                        data: res,
                        msg,
                    } = data.data
                    
                    if (status === 200) {
                        reslove({
                            status: status,
                            data: res,
                            message: msg,
                        })
                        // 需要重新登录
                    }else if (status === 401) {
                        this._Vue.prototype.$message.error(msg)
                        this._Router.replace({
                            path: '/login'
                        })
                        reject(msg)
                        // 需要重新登录
                    } else if (String(status).includes('50')) {
                        this._Vue.prototype.$message.error(msg)
                        this._Router.replace({
                            path: '/login'
                        })
                        reject(msg)
                    } else {
                        if (options.error) {
                            this.errorHandler('message', {
                                message: msg
                            }, reject)
                        } else {
                            reject(data)
                        }
                    }
                } else {
                    options.error && this.errorHandler('message', {
                        message: '系统异常'
                    }, reject)
                }
            }).catch(err => {
                options.error && this.errorHandler(options.errorConfig.type, {
                    title: '温馨提示',
                    message: err.message
                }, reject)
                if(err.message && err.message.includes('401')){
                    this._Router.replace({
                        path: '/login'
                    })
                }
            }).finally(() => {
                LOADING && LOADING.close()
                TIMER && window.clearTimeout(TIMER)
                TIMER = null
            })
        })
    }

    /**
     * 报错处理函数
     * @param {String} type 处理类型
     *  - message   消息提示
     *  - alert     弹框提示
     * @param {Object} options 提示内容配置，同elementUI Message消息提示和MessageBox弹框提示配置
     * @param {Funtion} reject Promise 错误回调
     */
    errorHandler(type, options, reject) {
        this._Vue.prototype.$message.error(options.message || '系统异常')
        reject(options)
    }
}